import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M773.596457,1069.6538 L1484.68163,1780.73898 C1524.31409,1820.37144 1589.01792,1820.37144 1628.75986,1780.73898 L1767.03555,1642.35381 C1786.30437,1623.08499 1796.92411,1597.5757 1796.92411,1570.42418 C1796.92411,1543.16318 1786.30437,1517.65388 1767.03555,1498.38506 L1068.32183,799.671348 L1079.81743,767.045731 C1143.31696,588.371211 1098.10092,386.596003 964.532953,253.02804 C840.818366,129.422935 659.406797,82.0172562 492.884773,124.715211 L765.166348,396.996786 C797.682483,429.40344 815.528038,472.648804 815.528038,518.740699 C815.528038,564.723113 797.682483,607.968477 765.166348,640.484612 L654.48011,751.17085 C587.258201,818.173795 478.104711,818.173795 410.992284,751.17085 L138.710709,478.889275 C96.122236,645.4113 143.418432,826.822868 267.023538,950.537456 C390.738126,1074.25204 573.244514,1122.86202 743.050997,1077.75547 L773.596457,1069.6538 Z M1556.61126,1920 C1502.52719,1920 1448.44311,1899.30791 1407.2779,1858.14271 L740.094984,1190.95979 C541.93268,1232.6724 333.369592,1171.69097 189.619809,1027.94118 C14.4487116,852.770087 -35.2560874,582.787632 65.7957397,356.269506 L98.2023928,283.573501 L488.396013,673.767121 C512.810485,698.072111 552.66191,698.072111 577.076381,673.767121 L687.762619,563.080884 C699.586668,551.147353 706.046102,535.491436 706.046102,518.740699 C706.046102,501.989963 699.586668,486.224564 687.762619,474.400515 L297.568998,84.2068949 L370.265004,51.8002418 C596.892612,-49.2515852 866.875066,0.453213761 1041.93668,175.51483 C1196.9631,330.650733 1254.76957,560.672281 1193.78813,770.330189 L1844.43927,1420.98134 C1884.40018,1460.83276 1906.40605,1513.9315 1906.40605,1570.42418 C1906.40605,1626.80738 1884.40018,1679.90611 1844.43927,1719.75754 L1706.16359,1858.14271 C1664.8889,1899.30791 1610.80482,1920 1556.61126,1920 L1556.61126,1920 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconAdminToolsLine = /*#__PURE__*/function (_Component) {
  _inherits(IconAdminToolsLine, _Component);

  var _super = _createSuper(IconAdminToolsLine);

  function IconAdminToolsLine() {
    _classCallCheck(this, IconAdminToolsLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconAdminToolsLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconAdminTools",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconAdminToolsLine.displayName = "IconAdminToolsLine";
  return IconAdminToolsLine;
}(Component);

IconAdminToolsLine.glyphName = 'admin-tools';
IconAdminToolsLine.variant = 'Line';
IconAdminToolsLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconAdminToolsLine;
export { IconAdminToolsLine };